<template>
  <div
    class="light-blue-banner"
    :style="{ padding: exposedHeight === 260 ? '62px 0' : '103px 0 40px' }"
  >
    <div class="banner-container">
      <div class="banner-content">
        <slot>
          <h1 class="banner-title">{{ title }}</h1>
        </slot>
      </div>
    </div>
  </div>
  <!-- 主要內容區塊錨點 (位於 Banner 之下，搭配 Skip Link 與 Alt+C 快速鍵) -->
  <div id="main-content" tabindex="-1" class="main-content-anchor">
    <a
      id="accesskey-c"
      href="#accesskey-c"
      accesskey="C"
      class="accesskey-brick sr-only-focusable"
      title="主要內容區塊，快捷鍵：Alt+C"
      aria-label="主要內容區塊"
    >:::</a>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: "" },
  exposedHeight: { type: Number, default: 220 },
});
</script>

<style scoped lang="scss">
.light-blue-banner {
  background: linear-gradient(
      0deg,
      rgba(0, 139, 205, 0.1),
      rgba(0, 139, 205, 0.1)
    ),
    var(--Background-Layer1, #ffffff);
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.banner-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  width: 100%;
}

.banner-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  min-height: 135px;
}

.banner-title {
  font-family: "Noto Sans TC", sans-serif;
  font-size: 40px;
  font-weight: 700;
  color: var(--Sky-900, #004a89);
  margin: 0 0 10px;
  line-height: 1.2;
}

@media (max-width: 768px) {
  .banner-title {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .banner-title {
    font-size: 24px;
  }
}
</style>